//TODO: Migrate Campaign Saga Here

import { all, put, select, takeLatest } from 'redux-saga/effects';
import { modules } from 'veritone-redux-common';
import _ from 'lodash';

import constants, { loadingStatus } from '../../../../helpers/constant';
import { SCHEDULE_REPORT_FORMAT } from '../../../../pages/ScheduleReport/constants';
import { showToast } from '../notification';
import * as Actions from './actions';
import {
  getScheduleReportsApi,
  deleteReportApi,
  createScheduleReportApi,
  updateScheduleReportApi,
  updateReportApi
} from '../../../../helpers/scheduleReportApi';
import {
  updateReportConfigByKey,
  reportStep,
  namespace as REPORT_BUILDER_NS
} from '../reportBuilder/actions';
import { namespace as CAMPAIGN_NAMESPACE } from '../campaign';
import { goToCampaignPage, goToCreateReport } from '../../routing/actions';

const {
  config: { getConfig }
} = modules;

const parseReceivers = (mails = []) => (mails || []).join(', ');

// const parseReportFormat = (formats = []) =>
//   formats.reduce((raws, currentFormat) => {
//     raws[currentFormat] = true;
//     return raws;
//   }, {});

// MNE-662 - Change from checkbox to radio. Will keep above code if requirement change in feature.
const parseReportFormat = (formats = []) =>
  (formats || []).length === 0
    ? { type: SCHEDULE_REPORT_FORMAT.VERTICAL_PDF }
    : { type: formats[0] };

const parseScheduleReportFromServer = scheduleReport => ({
  ...scheduleReport,
  scheduleReportReceivers: parseReceivers(
    _.get(scheduleReport, 'scheduleReportReceivers')
  ),
  scheduleReportRawFormat: parseReportFormat(
    _.get(scheduleReport, 'scheduleReportFormat')
  )
});

/**
 * get all schedules of existed report
*/
function* getScheduleReportsSaga(action) {
  const config = yield select(state => state.config);
  const { query } = action.payload;

  if (!query) {
    return ;
  }
  yield put(
    Actions.loadReport(Actions.COMPONENTS.LIST, {
      loading: true,
      loaded: false
    })
  );

  const fetchResults = yield getScheduleReportsApi(config.urlApi, query);

  if (fetchResults && !fetchResults.error) {
    const scheduleReport = (fetchResults.data || []).map(scheduleReport =>
      parseScheduleReportFromServer(scheduleReport)
    );

    yield put(Actions.setScheduleReports(scheduleReport));
  } else {
    yield put(Actions.setScheduleReports([]));
    yield put(
      showToast({
        type: constants.FAILED,
        action: 'Dismiss',
        message: 'Fail to load schedule reports'
      })
    );
  }

  yield put(
    Actions.loadReport(Actions.COMPONENTS.LIST, {
      loading: false,
      loaded: true
    })
  );
}

function* createCustomizedReportSaga(action) {
  yield updateSaveReportStatus(loadingStatus.loading);
  const { data = {} } = action.payload;
  const config = yield select(getConfig);
  const state = yield select();
  const reportBuilder = _.get(state, [REPORT_BUILDER_NS], {});
  const reportName = _.get(reportBuilder, 'reportProperties.reportName', '');
  const reportChartSelector = _.get(reportBuilder, 'chartSelector', {});

  const {
      campaignId,
  } = data;
  const campaign = _.get(state, [CAMPAIGN_NAMESPACE, 'byId', campaignId], {});
  const { chartSelector, adPerformanceCalendar } = campaign;
  // add report builder data
  const newData = {
    campaignId,
    reportName,
    reportLayout: {
      ...reportBuilder,
      reportChartSelector,
      chartSelector,
      adPerformanceCalendar,
      isGlossaryReport: true
    }
  };

  const creatingResult = yield createScheduleReportApi(
    config.urlApi,
    newData
  );
  if (!creatingResult || creatingResult.error) {
    const toast = {
      message: 'Something went wrong saving the customized report',
      action: 'Dismiss',
      type: constants.FAILED
    };
    yield put(showToast(toast));
    yield updateSaveReportStatus(loadingStatus.error);
    return;
  }

  const reportId = _.get(creatingResult, 'data.reportId');
  const toast = {
    message: 'Save the customized report successfully',
    action: 'Dismiss',
    type: constants.SUCCESS
  };

  yield put(showToast(toast));
  yield updateScheduleReportList(creatingResult.data)
  yield put(
    Actions.modifyReports(
      Actions.ACTION_TYPES.MODIFY_REPORT,
      parseScheduleReportFromServer(creatingResult.data),
      reportId
    )
  );
  yield handleSaveChangeReport(action, reportId);
}

function* createScheduleForTheReportSaga(action) {
  const { data } = action.payload;
  const config = yield select(getConfig);
  const state = yield select();
  const reportBuilder = _.get(state, [REPORT_BUILDER_NS], {});
  const reportName = _.get(reportBuilder, 'reportProperties.reportName', '');
  const reportChartSelector = _.get(reportBuilder, 'chartSelector', {});

  const campaignId = _.get(data, 'campaignId');
  const campaign = _.get(state, [CAMPAIGN_NAMESPACE, 'byId', campaignId], {});
  const { chartSelector, adPerformanceCalendar } = campaign;

  yield put(
    Actions.loadReport(Actions.COMPONENTS.SCHEDULE_REPORT_FORM, {
      loading: true,
      loaded: false
    })
  );

  // add report builder data
  const newData = {
    ...data,
    reportName,
    reportLayout: {
      ...reportBuilder,
      reportChartSelector,
      chartSelector,
      adPerformanceCalendar
    }
  };

  const createScheduleReportResult = yield createScheduleReportApi(
    config.urlApi,
    newData
  );

  if (!createScheduleReportResult || createScheduleReportResult.error) {
    const toast = {
      message: 'Something went wrong',
      action: 'Dismiss',
      type: constants.FAILED
    };
    yield put(showToast(toast));
    yield put(
      Actions.loadReport(Actions.COMPONENTS.SCHEDULE_REPORT_FORM, {
        loading: false,
        loaded: true,
        hasError: true,
      })
    );
    return;
  }

  const toast = {
    message: 'Set schedule for the report successfully',
    action: 'Dismiss',
    type: constants.SUCCESS
  };

  yield put(showToast(toast));
  const newScheduleReport = _.get(createScheduleReportResult, 'data') || {};
  const { reportId } = newScheduleReport;
  yield put(
    Actions.modifyReports(
      Actions.ACTION_TYPES.MODIFY_REPORT,
      parseScheduleReportFromServer(newScheduleReport),
      reportId,
    )
  );
  yield put(
    Actions.loadReport(Actions.COMPONENTS.SCHEDULE_REPORT_FORM, {
      loading: false,
      loaded: true
    })
  );
}

function* deleteReportSaga(action) {
  const { scheduleReport, redirectOption } = action.payload;
  const { reportId, reportName } = scheduleReport;

  const config = yield select(getConfig);

  yield put(
    Actions.loadReport(Actions.COMPONENTS.DELETE_REPORT, {
      loading: true,
      loaded: false,
      reportId,
    })
  );

  const data = yield deleteReportApi(config.urlApi, { reportId });
  if (!data || data.error) {
    const toast = {
      message: `Something went wrong with deleting report ${reportName}`,
      action: 'Dismiss',
      type: constants.FAILED
    };
    yield put(
      Actions.loadReport(Actions.COMPONENTS.DELETE_REPORT, {
        loading: false,
        loaded: true,
        reportId,
      })
    );
    return yield put(showToast(toast));
  }

  const toast = {
    message: `Report ${reportName} deleted successfully!`,
    action: 'Dismiss',
    type: constants.SUCCESS
  };

  yield put(showToast(toast));
  yield put(
    Actions.modifyReports(
      Actions.ACTION_TYPES.REMOVE_REPORT,
      null,
      reportId
    )
  );
  yield put(
    Actions.loadReport(Actions.COMPONENTS.DELETE_REPORT, {
      loading: false,
      loaded: true,
      reportId,
    })
  );

  if (redirectOption) {
    const {
      advertiserId,
      campaignId,
      tab
    } = redirectOption;
    yield put(goToCampaignPage(advertiserId, campaignId, tab))
  }
}

function* updateScheduleReportSaga(action) {
  const { scheduleReport, isLayoutUpdated } = action.payload;
  const { reportId, campaignId } = scheduleReport;
  const config = yield select(getConfig);
  let data = scheduleReport;
  if (isLayoutUpdated) {
    const state = yield select();
    const reportBuilder = _.get(state, [REPORT_BUILDER_NS], {});
    const reportName = _.get(reportBuilder, 'reportProperties.reportName', '');
    const reportChartSelector = _.get(reportBuilder, 'chartSelector', {});
    const campaign = _.get(state, [CAMPAIGN_NAMESPACE, 'byId', campaignId], {});
    const { chartSelector, adPerformanceCalendar } = campaign;
    data = {
      ...scheduleReport,
      reportName,
      reportLayout: {
        ...reportBuilder,
        reportChartSelector,
        chartSelector,
        adPerformanceCalendar
      }
    };
  }

  yield put(
    Actions.loadReport(Actions.COMPONENTS.SCHEDULE_REPORT_FORM, {
      loading: true,
      loaded: false
    })
  );

  const updatedScheduleReportResult = yield updateScheduleReportApi(
    config.urlApi,
    data
  );

  if (!updatedScheduleReportResult || updatedScheduleReportResult.error) {
    const toast = {
      message: 'Something went wrong while updating a schedule report',
      action: 'Dismiss',
      type: constants.FAILED
    };
    yield put(
      Actions.loadReport(Actions.COMPONENTS.SCHEDULE_REPORT_FORM, {
        loading: false,
        loaded: true
      })
    );
    return yield put(showToast(toast));
  }

  //Update schedule report in reducer
  yield put(
    Actions.modifyReports(
      Actions.ACTION_TYPES.MODIFY_REPORT,
      parseScheduleReportFromServer(updatedScheduleReportResult.data),
      reportId
    )
  );

  const toast = {
    message: 'Schedule Report Updated',
    action: 'Dismiss',
    type: constants.SUCCESS
  };

  yield put(showToast(toast));
  yield put(
    Actions.loadReport(Actions.COMPONENTS.SCHEDULE_REPORT_FORM, {
      loading: false,
      loaded: true
    })
  );
}

function* updateCustomizedReportSaga(action) {
  yield updateSaveReportStatus(loadingStatus.loading);
  const { data } = action.payload;
  const {
    reportId,
    campaignId,
} = data;
  const config = yield select(getConfig);
  const state = yield select();
  const reportBuilder = _.get(state, [REPORT_BUILDER_NS], {});
  const reportName = _.get(reportBuilder, 'reportProperties.reportName', '');
  const reportChartSelector = _.get(reportBuilder, 'chartSelector', {});
  const campaign = _.get(state, [CAMPAIGN_NAMESPACE, 'byId', campaignId], {});
  const { chartSelector, adPerformanceCalendar } = campaign;
  const reportData =   {
    reportLayout: {
      ...reportBuilder,
      reportChartSelector,
      adPerformanceCalendar,
      chartSelector,
    },
    reportId,
    campaignId,
    reportName,
  }

  const updatedReportResult = yield updateReportApi(
    config.urlApi,
    reportData
  );

  if (!updatedReportResult || updatedReportResult.error) {
    const toast = {
      message: 'Something went wrong while updating the report',
      action: 'Dismiss',
      type: constants.FAILED
    };
    yield updateSaveReportStatus(loadingStatus.error);
    return yield put(showToast(toast));
  }
  //Update report in reducer
  yield put(
    Actions.modifyReports(
      Actions.ACTION_TYPES.MODIFY_REPORT,
      reportData,
      reportId
    )
  );

  const toast = {
    message: 'Customized Report Updated',
    action: 'Dismiss',
    type: constants.SUCCESS
  };

  yield put(showToast(toast));
  yield updateScheduleReportList(updatedReportResult.data, reportId);
  yield handleSaveChangeReport(action, reportId);
}

function* updateGlossaryReportSaga(action) {
  const { data } = action.payload;
  const {
    reportId,
    campaignId,
    isChecked
} = data;
  const config = yield select(getConfig);
  const state = yield select();
  const reportBuilder = _.get(state, [REPORT_BUILDER_NS], {});
  const reportName = _.get(reportBuilder, 'reportProperties.reportName', '');
  const reportChartSelector = _.get(reportBuilder, 'chartSelector', {});
  const campaign = _.get(state, [CAMPAIGN_NAMESPACE, 'byId', campaignId], {});
  const { chartSelector, adPerformanceCalendar } = campaign;
  const reportData =   {
    reportLayout: {
      ...reportBuilder,
      reportChartSelector,
      adPerformanceCalendar,
      chartSelector,
      isGlossaryReport: isChecked
    },
    reportId,
    campaignId,
    reportName,
  }

  const updatedReportResult = yield updateReportApi(
    config.urlApi,
    reportData
  );

  if (!updatedReportResult || updatedReportResult.error) {
    const toast = {
      message: 'Something went wrong while updating the glossary report',
      action: 'Dismiss',
      type: constants.FAILED
    };
    yield updateSaveReportStatus(loadingStatus.error);
    return yield put(showToast(toast));
  }
  //Update report in reducer
  yield put(
    Actions.modifyReports(
      Actions.ACTION_TYPES.MODIFY_REPORT,
      reportData,
      reportId
    )
  );

  const toast = {
    message: 'Report glossary has been updated',
    action: 'Dismiss',
    type: constants.SUCCESS
  };

  yield put(showToast(toast));
  yield updateScheduleReportList(updatedReportResult.data, reportId);
}


function* handleSaveChangeReport(action, reportId) {
  const { data } = action.payload || {};
  const {
    isCloseCustomReportPage,
    advertiserId,
    campaignId,
    currentTab,
  } = data || {};
  yield put(updateReportConfigByKey('haveUnSaveData', false));
  yield updateSaveReportStatus(loadingStatus.success);
  if (isCloseCustomReportPage) {
    yield put(goToCampaignPage(advertiserId, campaignId, currentTab))
  } else {
    yield put(goToCreateReport(advertiserId, campaignId, currentTab, reportStep.view, reportId));
  }
}

function* updateSaveReportStatus(status) {
  yield put(Actions.updateLoadingStatus(
    Actions.COMPONENTS.REPORT,
    {
      status,
    }
  ))
}

function* updateScheduleReportList(newScheduleReport, scheduleReportId) {
  yield put(
    Actions.modifyReports(
      Actions.ACTION_TYPES.MODIFY_REPORT,
      parseScheduleReportFromServer(newScheduleReport),
      scheduleReportId,
    )
  );
}

export default function* scheduleReport() {
  const ActionType = Actions.ACTION_TYPES;

  yield all([
    takeLatest(ActionType.GET_SCHEDULE_REPORTS_SAGA, getScheduleReportsSaga),
    takeLatest(ActionType.CREATE_CUSTOMIZED_REPORT, createCustomizedReportSaga),
    takeLatest(ActionType.UPDATE_CUSTOMIZED_REPORT, updateCustomizedReportSaga),
    takeLatest(ActionType.UPDATE_GLOSSARY_REPORT, updateGlossaryReportSaga),
    takeLatest(ActionType.CREATE_SCHEDULE_REPORT_SAGA, createScheduleForTheReportSaga),
    takeLatest(ActionType.DELETE_REPORT_SAGA, deleteReportSaga),
    takeLatest(ActionType.UPDATE_SCHEDULE_REPORT_SAGA, updateScheduleReportSaga)
  ]);
}
